import React from "react";
import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import useAuth from "hooks/useAuth";

const AdminManageGuard = ({ children }) => {
  const { user, isLoggedIn } = useAuth();

  if (
    isLoggedIn &&
    user &&
    (user.role !== "MASTER" || user.canEditAdmin === false)
  ) {
    return <Navigate to="/dashboard/default" replace />;
  }

  return children;
};

AdminManageGuard.propTypes = {
  children: PropTypes.node,
};

export default AdminManageGuard;
